import moment from 'moment';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function ReportTilesRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.ReportTiles', {
		url: '/report/tiles',
		controllerAs: 'vm',
		controller: ReportTilesCtrl,
		templateUrl: '/ng/hub/Report/Tiles/ReportTilesCtrl.html?' + window.BUILD,
		permission: ['manage_users'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Report/Tiles/ReportTilesCtrl.css'),
			$title: () => 'Analytics Overview',
		},
	});
}

export class ReportTilesCtrl {
	constructor(Api) {
		'ngInject';
		// save injections
		this.Api = Api;
		// define colors
		this.colors = [
			'#F05A24', // 0
			'#EF4E4A', // 1
			'#EE3F65', // 2
			'#EC297B', // 3
			'#E3236C', // 4
			'#D91C5C', // 5
			'#BC1E60', // 6
			'#9E1F63', // 7
			'#992271', // 8
			'#952480', // 9
			'#90278E', // 10
			'#7A2A8F', // 11
			'#652D90', // 12
			'#502980', // 13
			'#3B2671', // 14
			'#262261', // 15
			'#27286D', // 16
			'#292D78', // 17
			'#2A3384', // 18
			'#2B388F', // 19
			'#2A4F9F', // 20
			'#2965AF', // 21
			'#277CC0', // 22
			'#2692D0', // 23
			'#25A9E0', // 24
		];
		this.colors3x2 = [0, 3, 7, 24, 20, 16].map(n => this.colors[n]);
		this.tiles = [
			{
				label: 'Searches',
				icon: '/angular/assets/img/icons/search.svg',
				endpoint: '/analytics/total/searches?start&end&superadmin_exclusion_check',
				type: 'number',
			},
			{
				label: 'Logins',
				icon: '/angular/assets/img/icons/unlock.svg',
				endpoint: '/analytics/total/logins?start&end&superadmin_exclusion_check',
				type: 'number',
			},
			{
				label: 'Active Users',
				icon: '/angular/assets/img/icons/user.svg',
				endpoint: '/analytics/total/active_users?start&end&superadmin_exclusion_check',
				type: 'number',
			},
			{
				label: 'Top Searchers',
				icon: false,
				endpoint:
					'/analytics/data/top-search-user?limit=5&start&end&tz_offset&superadmin_exclusion_check&roles=intel_leader,executive,member',
				type: 'bullets',
			},
			{
				label: 'Top Logins',
				icon: false,
				endpoint: '/analytics/top_logins?limit=5&start&end&tz_offset&superadmin_exclusion_check',
				type: 'bullets',
			},
			{
				label: 'Top Contributors',
				icon: false,
				endpoint: '/analytics/data/top-post-contributor?limit=5&start&end&tz_offset&superadmin_exclusion_check',
				type: 'bullets',
			},
		];
		this.tiles.forEach((tile, i) => {
			tile.color = this.colors3x2[i];
		});
		this.dateRange = [moment().add(-3, 'months'), moment()];
		this.run();
	}
	run() {
		this.isLoading = true;
		this.criteria = {
			start: moment(this.dateRange[0]).format(),
			end: moment(this.dateRange[1]).endOf('day').format(),
			tz_offset: new Date().getTimezoneOffset(),
			superadmin_exclusion_check: true,
		};
		const requests = this.tiles.map(tile => {
			const url = tile.endpoint.replace(/([?&])([\w_]+)(=)?/g, ($0, glue, param, eq) => {
				if (eq) {
					// param value already provided
					return $0;
				}
				return glue + param + '=' + encodeURIComponent(this.criteria[param]);
			});
			return this.Api.get(url, {}, { Hubs: 'account' });
		});
		Promise.all(requests).then(
			responses => {
				responses.map((data, i) => (this.tiles[i].data = data));
				this.isLoading = false;
			},
			error => {
				this.error = error;
				this.isLoading = false;
			}
		);
	}
}
